import { Button, Menu } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconSettings } from "@tabler/icons-react";
import { useCallback } from "react";
import WithdrawModal from "src/generator/_Modals/WithdrawModal/WithdrawModal";
import { useCheckPerm, useIsNewEntry } from "src/hooks";

interface Props {
  hamburger?: boolean;
}

const WithdrawButton = ({ hamburger }: Props) => {
  const [opened, { open, close }] = useDisclosure(false);
  const isNewEntry = useIsNewEntry();
  const checkPerm = useCheckPerm();

  const Component = useCallback(
    () =>
      hamburger ? (
        <Menu.Item
          disabled={isNewEntry}
          color="red"
          leftSection={<IconSettings size={20} />}
          onClick={open}>
          Withdraw
        </Menu.Item>
      ) : (
        <Button
          disabled={isNewEntry}
          variant="outline"
          color="red"
          onClick={open}
          leftSection={<IconSettings />}>
          Withdraw
        </Button>
      ),
    [hamburger, isNewEntry, open],
  );

  if (!checkPerm("deleteentries")) {
    return <></>;
  }

  return (
    <>
      <Component />
      {opened && <WithdrawModal opened={opened} close={close} />}
    </>
  );
};

export default WithdrawButton;
